import { checkStatus, download } from 'helper/utils';
import { getAuthHeader } from 'helper/authHeader';

export const postData = async (api, request) => {
	const { headers = {} } = getAuthHeader(request);
	const requestBody = request?.requestBody;

	const response = await fetch(api, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...headers
		},
		body: JSON.stringify(requestBody)
	});

	checkStatus(response?.status);
	const statusCode = await response?.status;

	const json = await response?.json();
	return { ok: response.ok, json, statusCode, data: json };
};

export const postDownload = async (api, request) => {
	const { headers = {} } = getAuthHeader(request);
	const requestBody = request?.requestBody;
	const downloadReq = { reportId: requestBody?.reportId };
	const response = await fetch(api, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...headers
		},
		body: JSON.stringify(downloadReq)
	});

	const json = await response?.json();
	if (response?.ok) {
		download(json?.signedUrl, requestBody?.fileUrl);
	}

	checkStatus(response?.status);
	const statusCode = await response?.status;

	return { ok: response.ok, statusCode, data: json };
};
